/**
 * Helper utilities for timeline display and formatting
 */

import { TimelineStep } from './organize-timeline.util';

/**
 * Calculate duration between two dates and format it
 */
export const calculateDuration = (start: string, end: string): string => {
  const startTime = new Date(start).getTime();
  const endTime = new Date(end).getTime();
  const durationMs = endTime - startTime;

  if (durationMs < 1000) {
    return `${durationMs}ms`;
  } else if (durationMs < 60000) {
    return `${Math.round(durationMs / 1000)}s`;
  } else {
    return `${Math.round(durationMs / 60000)}m`;
  }
};

/**
 * Generate a unique key for a child step
 */
export const getStepKey = (step: TimelineStep, index: number): string => {
  if ('executionId' in step.data) {
    return step.data.executionId + index;
  }
  return `step-${index}`;
};

/**
 * Format a field name from camelCase to readable format
 * Handles custom field format (customField:fieldName)
 */
export const formatFieldName = (fieldName: string): string => {
  // Handle custom field format (customField:fieldName)
  if (fieldName.includes(':')) {
    const parts = fieldName.split(':');
    fieldName = parts[parts.length - 1];
  }

  // Convert camelCase to Title Case
  return fieldName
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
};

/**
 * Format trigger ID for display
 * Removes common prefixes and converts to Title Case
 */
export const formatTriggerId = (triggerId: string): string => {
  return triggerId
    .replace('llamadapro.trigger.', '')
    .replace(/_/g, ' ')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Format error message for user-friendly display
 * Converts technical errors into readable, actionable messages
 */
export const formatErrorMessage = (errorMessage: string): string => {
  // Handle BAML Validation Errors
  if (errorMessage.includes('BamlValidationError')) {
    return 'Ocurrió un error de validación.';
  }

  // Return original message if it's short and understandable
  return errorMessage;
};
